module.exports = __webpack_public_path__ + "img/RegFees-OD-cafe.f069f975.svg";